/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkComment } from '../models/work-comment';
import { WorkCreateCommentDto } from '../models/work-create-comment-dto';

@Injectable({ providedIn: 'root' })
export class WorkCommentsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `commentsV1ControllerCreate()` */
  static readonly CommentsV1ControllerCreatePath = '/v1/comments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentsV1ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commentsV1ControllerCreate$Response(
    params: {
      body: WorkCreateCommentDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkComment>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCommentsService.CommentsV1ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkComment>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentsV1ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commentsV1ControllerCreate(
    params: {
      body: WorkCreateCommentDto
    },
    context?: HttpContext
  ): Observable<WorkComment> {
    return this.commentsV1ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkComment>): WorkComment => r.body)
    );
  }

}
